import axios from "axios";
import { env } from "../config/env";

const DRIVER_API_PATH = "/careadmin/driver/";

const driverClient = axios.create({
  baseURL: env.API_ENDPOINT_URL || env.DRIVER_PUBLIC_API_ENDPOINT_URL,
  headers: {
    "x-api-key": env.API_ENDPOINT_KEY,
  },
});

const buildActionPath = (action, query = {}) => {
  const params = new URLSearchParams({ func: action });

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });

  return `${DRIVER_API_PATH}?${params.toString()}`;
};

const isFunctionNotFound = (error) => (
  error?.response?.status === 404
  && error?.response?.data?.code === "FUNCTION_NOT_FOUND"
);

const postExternalAction = async (action, deployedAction, body) => {
  try {
    return await driverClient.post(buildActionPath(action), body);
  } catch (error) {
    if (!isFunctionNotFound(error)) throw error;
    return driverClient.post(buildActionPath(deployedAction), body);
  }
};

export const getExternalDeliveryRequestById = (deliveryRequestId) => (
  driverClient.get(
    buildActionPath("GetExternalDeliveryRequestById", {
      delivery_request_id: deliveryRequestId,
    })
  )
);

export const externalDriverResponse = (deliveryRequestId, status, reason = "") => (
  postExternalAction(
    "GetExternalDriverResponse",
    "ExternalDriverResponse",
    { delivery_request_id: String(deliveryRequestId), status, reason }
  )
);

export const externalStartDelivery = (deliveryRequestId) => (
  postExternalAction(
    "GetExternalStartDelivery",
    "ExternalStartDelivery",
    { delivery_request_id: String(deliveryRequestId) }
  )
);

export const externalCompleteDelivery = (deliveryRequestId, remarks = "") => (
  postExternalAction(
    "GetExternalCompleteDelivery",
    "ExternalCompleteDelivery",
    { delivery_request_id: String(deliveryRequestId), remarks }
  )
);
